import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "top",
  class: "flex flex-col min-h-screen bg-paper text-left"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "h-16" }, null, -1)
const _hoisted_3 = { class: "flex-1 py-10 px-6 md:px-8 container mx-auto max-w-5xl" }

import HeaderPortafolio from '@/components/portafolio/HeaderPortafolio.vue';
import BannerPrincipal from '@/components/portafolio/BannerPrincipal.vue';
import ProyectosFrontend from '@/components/portafolio/ProyectosFrontend.vue';
import ProyectosBackend from '@/components/portafolio/ProyectosBackend.vue';
import ExperienciaProfesional from '@/components/portafolio/ExperienciaProfesional.vue';
import Habilidades from '@/components/portafolio/Habilidades.vue';
import SobreMi from '@/components/portafolio/SobreMi.vue';
import Contacto from '@/components/portafolio/Contacto.vue';
import FooterPortafolio from '@/components/portafolio/FooterPortafolio.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PortafolioView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderPortafolio),
    _hoisted_2,
    _createElementVNode("main", _hoisted_3, [
      _createVNode(BannerPrincipal),
      _createVNode(SobreMi),
      _createVNode(ExperienciaProfesional),
      _createVNode(Habilidades),
      _createVNode(ProyectosBackend),
      _createVNode(ProyectosFrontend),
      _createVNode(Contacto)
    ]),
    _createVNode(FooterPortafolio)
  ]))
}
}

})